import { allModelOptions } from '../../../utils/ModelOptions';
import { GlobalConfiguration } from '../../../models/GlobalConfiguration';

export function getFieldDisplayValue(val: unknown): string {
  if (typeof val === 'boolean') return val ? 'On' : 'Off';
  if (val == null || val === '') return '—';
  return val.toString();
}

/** Ensures current backend value is always included in model dropdown options. */
export function getDropdownOptions(config: GlobalConfiguration | null, fieldKey: string): string[] {
  return [
    ...new Set([...allModelOptions, (config as unknown as Record<string, unknown>)?.[fieldKey]]),
  ].filter(Boolean) as string[];
}

export function broadcastGlobalConfigUpdate(config: GlobalConfiguration): void {
  try {
    if (typeof BroadcastChannel !== 'undefined') {
      const channel = new BroadcastChannel('global-config-updates');
      channel.postMessage({ type: 'CONFIG_UPDATED', config });
      channel.close();
    } else {
      localStorage.setItem('global-config-updated', Date.now().toString());
      localStorage.removeItem('global-config-updated');
    }
  } catch (error) {
    console.warn('Could not broadcast config update:', error);
  }
}

export function focusFieldByHash(hash: string): void {
  setTimeout(() => {
    const element = document.querySelector(`[data-field="${hash}"]`);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      element.classList.add('highlight-field');
      setTimeout(() => element.classList.remove('highlight-field'), 3000);
    }
  }, 100);
}
